export const PhotoShootQueryKeys = {
  GET_PHOTO_SHOOT: (venueId: string, token: string | null) => ['photoShoot', venueId, token],
  GET_PHOTO_SHOOT_LINK: (venueId: string) => ['photoShoot.link', venueId],
  DOWNLOAD_ZIP: (imageIds: string[], venueId: string, token: string | null) => [
    'photoShoot.downloadZip',
    venueId,
    token,
    ...imageIds,
  ],
  LOAD_IMAGE: (imageUrl: string) => ['photoShoot.loadImage', imageUrl],
};
